import axiosInstance from "@/api/axios-instance";

export async function getCoupons() {
  const response = await axiosInstance.get("/coupon");
  return response.data;
}
